import { createFileRoute } from '@tanstack/react-router'
import { Scheduler } from '@/features/scheduler'
import { requireActiveSubscription } from '@/lib/middleware'

export const Route = createFileRoute('/_authenticated/_organization/scheduler')(
  {
    beforeLoad: async () => requireActiveSubscription(),
    component: Scheduler,
  }
)
